import React from 'react';
import CheckboxWithLabel from '../CheckboxWithLabel';

function Option({ type, disabled, options, id }) {
  console.log('options ', options);
  if (!options) return;
  return Object.keys(options).map((e) => {
    return (
      <CheckboxWithLabel
        disabled={disabled}
        type={type}
        id={id}
        optionKey={e}
        text={e}
      />
    );
  });
}

export default Option;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/Option/index.jsx